import { render, staticRenderFns } from "./DoctorAsissHistory.vue?vue&type=template&id=03aded4a&scoped=true"
import script from "./DoctorAsissHistory.vue?vue&type=script&lang=js"
export * from "./DoctorAsissHistory.vue?vue&type=script&lang=js"
import style0 from "./DoctorAsissHistory.vue?vue&type=style&index=0&id=03aded4a&prod&scoped=true&lang=css"
import style1 from "./DoctorAsissHistory.vue?vue&type=style&index=1&id=03aded4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aded4a",
  null
  
)

export default component.exports